import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is m3

export const Volume: BaseQuantity = {
  id: "001volume",
  name: "volume",
  type: "numeric",
  value: "",
  symbol: "V",
  baseUnit: "m\u00b3",
  selectedUnit: "m\u00b3",
  units: [
    { name: "m\u00b3", fromConst: 1, toConst: 1 },
    { name: "dm\u00b3", fromConst: 1 / 10 ** 3, toConst: 10 ** 3 },
    { name: "cm\u00b3", fromConst: 1 / 100 ** 3, toConst: 100 ** 3 },
    { name: "mm\u00b3", fromConst: 1 / 1000 ** 3, toConst: 1000 ** 3 },
    { name: "l", fromConst: 1 / 10 ** 3, toConst: 10 ** 3 },
    { name: "dl", fromConst: 1 / (10 * 10 ** 3), toConst: 10 * 10 ** 3 },
    { name: "cl", fromConst: 1 / (100 * 10 ** 3), toConst: 100 * 10 ** 3 },
    { name: "ml", fromConst: 1 / (1000 * 10 ** 3), toConst: 1000 * 10 ** 3 },
    {
      name: "tbsp",
      fromConst: 1 / (1000 ** 3 / 15000),
      toConst: 1000 ** 3 / 15000,
    },
    {
      name: "tsp",
      fromConst: 1 / (1000 ** 3 / 5000),
      toConst: 1000 ** 3 / 5000,
    },
    { name: "in\u00b3", fromConst: 1 / 61023.7, toConst: 61023.7 },
    { name: "ft\u00b3", fromConst: 1 / 35.3147, toConst: 35.3147 },
    { name: "yd\u00b3", fromConst: 1 / 1.30795, toConst: 1.30795 },
    { name: "US gal", fromConst: 1 / 264.172, toConst: 264.172 },
    { name: "UK gal", fromConst: 1 / 219.969, toConst: 219.969 },
    { name: "US oz", fromConst: 1 / 33814, toConst: 33814 },
    { name: "UK oz", fromConst: 1 / 35195.1, toConst: 35195.1 },
    { name: "US pt", fromConst: 1 / 2113.38, toConst: 2113.38 },
    { name: "UK pt", fromConst: 1 / 1759.75, toConst: 1759.75 },
  ],
};
